var PutJobOnHoldBlockModel = /** @class */ (function () {
    function PutJobOnHoldBlockModel(data) {
        if (data === void 0) { data = undefined; }
        this.reasonDisplayName = '';
        this.reasonId = undefined;
        if (data) {
            this.reasonDisplayName = data['reasonDisplayName'] ? data['reasonDisplayName'] : '';
            this.reasonId = data['reasonId'] ? parseInt(data['reasonId']) : undefined;
        }
    }
    return PutJobOnHoldBlockModel;
}());
export { PutJobOnHoldBlockModel };
